import React, { useState, useEffect } from 'react';

const SearchResults = ({
    results,
    isLoading,
    viewMode = 'grid',
    onViewModeChange,
    onSortChange,
    onFilterChange
}) => {
    const [selectedPart, setSelectedPart] = useState(null);
    const [filters, setFilters] = useState({
        priceRange: [],
        availability: [],
        brands: [],
        categories: [],
        ratings: [],
        warranty: false,
        fastDelivery: false
    });
    const [showFilters, setShowFilters] = useState(false);

    // الخيارات المتاحة للتصفية
    const filterOptions = {
        priceRanges: [
            { id: '0-100', label: 'أقل من 100 ريال', count: 45 },
            { id: '100-300', label: '100 - 300 ريال', count: 128 },
            { id: '300-500', label: '300 - 500 ريال', count: 76 },
            { id: '500-1000', label: '500 - 1000 ريال', count: 34 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 },
            { id: '300-500', label: '300 - 500 ريال', count: 76 },
            { id: '500-1000', label: '500 - 1000 ريال', count: 34 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 },
            { id: '1000+', label: 'أكثر من 1000 ريال', count: 12 }
        ],
        availabilityOptions: [
            { id: 'in-stock', label: 'متوفر بالمخزن', count: 215 },
            { id: 'pre-order', label: 'طلب مسبق', count: 42 },
            { id: 'out-of-stock', label: 'غير متوفر', count: 18 }
        ],
        brandOptions: [
            { id: 'toyota', label: 'Toyota', count: 89 },
            { id: 'nissan', label: 'Nissan', count: 67 },
            { id: 'honda', label: 'Honda', count: 54 },
            { id: 'hyundai', label: 'Hyundai', count: 48 },
            { id: 'kia', label: 'Kia', count: 32 },
            { id: 'bosch', label: 'Bosch', count: 76 },
            { id: 'castrol', label: 'Castrol', count: 41 },
            { id: 'ngk', label: 'NGK', count: 29 }
        ],
        categoryOptions: [
            { id: 'engine', label: 'المحرك والوقود', count: 56 },
            { id: 'brakes', label: 'نظام الفرامل', count: 42 },
            { id: 'suspension', label: 'نظام التعليق', count: 38 },
            { id: 'electrical', label: 'الكهرباء والإلكترونيات', count: 67 },
            { id: 'interior', label: 'الديكورات الداخلية', count: 45 },
            { id: 'exterior', label: 'الديكورات الخارجية', count: 52 },
            { id: 'cooling', label: 'نظام التبريد', count: 31 },
            { id: 'transmission', label: 'نظام نقل الحركة', count: 28 }
        ],
        ratingOptions: [
            { id: '5', label: '5 نجوم', count: 87 },
            { id: '4', label: '4 نجوم فما فوق', count: 124 },
            { id: '3', label: '3 نجوم فما فوق', count: 48 }
        ]
    };

    // تحديث الفلاتر
    const handleFilterChange = (filterType, value) => {
        setFilters(prev => {
            const newFilters = { ...prev };

            if (Array.isArray(newFilters[filterType])) {
                if (newFilters[filterType].includes(value)) {
                    newFilters[filterType] = newFilters[filterType].filter(item => item !== value);
                } else {
                    newFilters[filterType] = [...newFilters[filterType], value];
                }
            } else {
                newFilters[filterType] = !newFilters[filterType];
            }

            return newFilters;
        });
    };

    // تطبيق الفلاتر
    const applyFilters = () => {
        if (onFilterChange) {
            onFilterChange(filters);
        }
    };

    // إعادة تعيين الفلاتر
    const resetFilters = () => {
        setFilters({
            priceRange: [],
            availability: [],
            brands: [],
            categories: [],
            ratings: [],
            warranty: false,
            fastDelivery: false
        });

        if (onFilterChange) {
            onFilterChange({
                priceRange: [],
                availability: [],
                brands: [],
                categories: [],
                ratings: [],
                warranty: false,
                fastDelivery: false
            });
        }
    };

    // تعداد الفلاتر المختارة
    const getActiveFiltersCount = () => {
        let count = 0;

        if (filters.priceRange.length > 0) count++;
        if (filters.availability.length > 0) count++;
        if (filters.brands.length > 0) count++;
        if (filters.categories.length > 0) count++;
        if (filters.ratings.length > 0) count++;
        if (filters.warranty) count++;
        if (filters.fastDelivery) count++;

        return count;
    };


    // إذا كان التحميل جارياً
    if (isLoading) {
        return (
            <div className="py-12">
                <div className="flex flex-col items-center justify-center">
                    <div className="relative">
                        <div className="w-20 h-20 border-4 border-gray-200 rounded-full"></div>
                        <div className="absolute top-0 left-0 w-20 h-20 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                    <div className="mt-6 text-center">
                        <h3 className="text-2xl font-semibold text-gray-800 mb-2">جاري البحث عن القطع...</h3>
                        <p className="text-gray-600">نبحث في قاعدة البيانات عن أفضل القطع المناسبة لسيارتك</p>
                    </div>

                    {/* محاكاة للكاردات أثناء التحميل */}
                    <div className="mt-10 w-full">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {[1, 2, 3].map((item) => (
                                <div key={item} className="bg-white rounded-2xl shadow-lg overflow-hidden animate-pulse">
                                    <div className="h-48 bg-gradient-to-r from-gray-200 to-gray-300"></div>
                                    <div className="p-6">
                                        <div className="h-6 bg-gray-200 rounded mb-4"></div>
                                        <div className="h-4 bg-gray-200 rounded mb-2 w-3/4"></div>
                                        <div className="h-4 bg-gray-200 rounded mb-6 w-1/2"></div>
                                        <div className="flex justify-between items-center">
                                            <div className="h-8 bg-gray-200 rounded w-24"></div>
                                            <div className="h-10 bg-gray-200 rounded w-32"></div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // إذا لم توجد نتائج
    if (results.length === 0) {
        return (
            <div className="text-center py-16 px-4">
                <div className="max-w-md mx-auto">
                    <div className="w-32 h-32 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg className="w-20 h-20 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">لم يتم العثور على قطع</h3>
                    <p className="text-gray-600 mb-8">لم نتمكن من العثور على قطع غيار تطابق معايير بحثك. حاول استخدام مصطلحات بحث مختلفة أو تصفح الفئات.</p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-800 transition-all duration-300 shadow-lg">
                            تصفح جميع الفئات
                        </button>
                        <button className="px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-300">
                            استعراض القطع الأكثر مبيعاً
                        </button>
                    </div>
                </div>
            </div>
        );
    }


    // عرض الكاردات في وضع الشبكة
    return (
        <div>
            {/* رأس نتائج البحث مع خيارات التصفية */}
            <div className="">

                {/* شريط النتائج */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white p-6 rounded-2xl shadow-lg mb-4">
                    <div className="mb-4 md:mb-0">
                        <h2 className="text-2xl font-bold text-gray-900 mb-1">
                            نتائج البحث
                            {results.length > 0 && (
                                <span className="text-blue-600 mr-2 text-2xl"> ({results.length})</span>
                            )}
                        </h2>
                        <p className="text-2xl  text-gray-600">عثرنا على قطع غيار تطابق بحثك</p>
                    </div>

                    <div className="flex flex-wrap gap-4">
                        {/* خيارات العرض */}
                        <div className="flex items-center space-x-2 space-x-reverse bg-gray-100 p-1 rounded-xl">
                            <button
                                className={`p-2 rounded-lg ${viewMode === 'grid' ? 'bg-white shadow-md' : 'hover:bg-gray-200'}`}
                                onClick={() => onViewModeChange('grid')}
                            >
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                                </svg>
                            </button>
                            <button
                                className={`p-2 rounded-lg ${viewMode === 'list' ? 'bg-white shadow-md' : 'hover:bg-gray-200'}`}
                                onClick={() => onViewModeChange('list')}
                            >
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                        </div>

                        {/* خيارات الترتيب */}
                        <div className="relative">
                            <select
                                className="px-4 py-2 pr-10 border border-gray-300 rounded-xl bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                                onChange={(e) => onSortChange(e.target.value)}
                                defaultValue="default"
                            >
                                <option value="default">الترتيب الافتراضي</option>
                                <option value="price-asc">السعر: من الأقل للأعلى</option>
                                <option value="price-desc">السعر: من الأعلى للأقل</option>
                                <option value="name">الاسم: أبجدي</option>
                                <option value="rating">التقييم: الأعلى أولاً</option>
                                <option value="popularity">الأكثر مبيعاً</option>
                                <option value="newest">الأحدث أولاً</option>
                            </select>
                            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>

                        {/* زر الفلاتر */}
                        <button
                            className="px-4 py-2 text-2xl  bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-xl font-medium hover:from-blue-700 hover:to-indigo-800 transition-all duration-300 flex items-center shadow-lg"
                            onClick={() => setShowFilters(!showFilters)}
                        >
                            <svg className="w-8 h-8 ml-2" fill="#ffffff" stroke="#000000" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                            </svg>
                            الفلاتر
                            {getActiveFiltersCount() > 0 && (
                                <span className="mr-2 bg-white text-blue-600 text-2xl font-bold w-6 h-6 rounded-full flex items-center justify-center">
                                    {getActiveFiltersCount()}
                                </span>
                            )}
                        </button>
                    </div>
                </div>

                {/* الفلاتر النشطة */}
                {getActiveFiltersCount() > 0 && (
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 rounded-2xl p-4 mb-4">
                        <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center">
                                <svg className="w-5 h-5 text-blue-600 ml-2" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
                                </svg>
                                <span className="font-semibold text-gray-800">الفلاتر المطبقة:</span>
                            </div>
                            <button
                                className="text-2xl text-blue-600 hover:text-blue-800 font-medium"
                                onClick={resetFilters}
                            >
                                إزالة الكل
                            </button>
                        </div>

                        <div className="flex flex-wrap gap-2">
                            {/* عرض الفلاتر النشطة */}
                            {filters.priceRange.map(rangeId => {
                                const range = filterOptions.priceRanges.find(r => r.id === rangeId);
                                return range && (
                                    <span key={rangeId} className="bg-white px-3 py-1 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">
                                        {range.label}
                                        <button
                                            className="mr-2 text-gray-400 hover:text-red-500"
                                            onClick={() => handleFilterChange('priceRange', rangeId)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                );
                            })}

                            {filters.brands.map(brandId => {
                                const brand = filterOptions.brandOptions.find(b => b.id === brandId);
                                return brand && (
                                    <span key={brandId} className="bg-white px-3 py-1 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">
                                        {brand.label}
                                        <button
                                            className="mr-2 text-gray-400 hover:text-red-500"
                                            onClick={() => handleFilterChange('brands', brandId)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                );
                            })}

                            {filters.categories.map(categoryId => {
                                const category = filterOptions.categoryOptions.find(c => c.id === categoryId);
                                return category && (
                                    <span key={categoryId} className="bg-white px-3 py-1 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">
                                        {category.label}
                                        <button
                                            className="mr-2 text-gray-400 hover:text-red-500"
                                            onClick={() => handleFilterChange('categories', categoryId)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                );
                            })}

                            {filters.ratings.map(ratingId => {
                                const rating = filterOptions.ratingOptions.find(r => r.id === ratingId);
                                return rating && (
                                    <span key={ratingId} className="bg-white px-3 py-1 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">
                                        {rating.label}
                                        <button
                                            className="mr-2 text-gray-400 hover:text-red-500"
                                            onClick={() => handleFilterChange('ratings', ratingId)}
                                        >
                                            ×
                                        </button>
                                    </span>
                                );
                            })}

                            {filters.warranty && (
                                <span className="bg-white px-3 py-1 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">
                                    ضمان مصنع
                                    <button
                                        className="mr-2 text-gray-400 hover:text-red-500"
                                        onClick={() => handleFilterChange('warranty', false)}
                                    >
                                        ×
                                    </button>
                                </span>
                            )}

                            {filters.fastDelivery && (
                                <span className="bg-white px-3 py-1 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">
                                    توصيل سريع
                                    <button
                                        className="mr-2 text-gray-400 hover:text-red-500"
                                        onClick={() => handleFilterChange('fastDelivery', false)}
                                    >
                                        ×
                                    </button>
                                </span>
                            )}
                        </div>
                    </div>
                )}

                {/* لوحة الفلاتر الكاملة */}
                {showFilters && (
                    <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border border-gray-200">
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-2xl font-bold text-gray-900">تصفية النتائج</h3>
                            <button
                                className="text-gray-500 hover:text-gray-700"
                                onClick={() => setShowFilters(false)}
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ">
                            {/* تصفية حسب السعر */}
                            <div className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl border border-gray-100 max-h-80">
                                <h4 className="font-semibold text-gray-800 mb-4 flex items-center">
                                    <svg className="w-5 h-5 text-green-600 ml-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2h1v6a1 1 0 001 1h2a1 1 0 001-1v-6h1a2 2 0 002-2V6a2 2 0 00-2-2H4z" clipRule="evenodd" />
                                    </svg>
                                    نطاق السعر
                                </h4>
                                <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                                    {filterOptions.priceRanges.map((range) => (
                                        <label key={range.id} className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded-lg">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.priceRange.includes(range.id)}
                                                    onChange={() => handleFilterChange('priceRange', range.id)}
                                                    className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                                    style={{ width: "20px" }}
                                                />
                                                <span className="mr-3 text-2xl font-bold text-gray-900 ">{range.label}</span>
                                            </div>
                                            {/* <span className="bg-gray-100 text-gray-600 text-2xl px-2 py-1 rounded-full">
                                                {range.count}
                                            </span> */}
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* تصفية حسب البراند */}
                            <div className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl border border-gray-100 max-h-80">
                                <h4 className="font-semibold text-gray-800 mb-4 flex items-center">
                                    <svg className="w-5 h-5 text-blue-600 ml-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z" clipRule="evenodd" />
                                    </svg>
                                    البراند
                                </h4>
                                <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                                    {filterOptions.brandOptions.map((brand) => (
                                        <label key={brand.id} className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded-lg">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.brands.includes(brand.id)}
                                                    onChange={() => handleFilterChange('brands', brand.id)}
                                                    className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                                    style={{ width: "20px" }}
                                                />
                                                <span className="mr-3 text-2xl font-bold text-gray-900 ">{brand.label}</span>
                                            </div>
                                            {/* <span className="bg-gray-100 text-gray-600 text-2xl px-2 py-1 rounded-full">
                                                {brand.count}
                                            </span> */}
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* تصفية حسب الفئة */}
                            <div className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl border border-gray-100 max-h-80">
                                <h4 className="font-semibold text-gray-800 mb-4 flex items-center">
                                    <svg className="w-5 h-5 text-purple-600 ml-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                    </svg>
                                    الفئة
                                </h4>
                                <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                                    {filterOptions.categoryOptions.map((category) => (
                                        <label key={category.id} className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded-lg">
                                            <div className="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.categories.includes(category.id)}
                                                    onChange={() => handleFilterChange('categories', category.id)}
                                                    className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                                    style={{ width: "20px" }}
                                                />
                                                <span className="mr-3 text-2xl font-bold text-gray-900 ">{category.label}</span>
                                            </div>
                                            {/* <span className="bg-gray-100 text-gray-600 text-2xl px-2 py-1 rounded-full">
                                                {category.count}
                                            </span> */}
                                        </label>
                                    ))}
                                </div>
                            </div>

                            {/* تصفية حسب التقييم والميزات */}
                            <div className="bg-gradient-to-br from-gray-50 to-white p-4 rounded-xl border border-gray-100 max-h-80">
                                <h4 className="font-semibold text-gray-800 mb-4">المزيد من الفلاتر</h4>
                                <div className="space-y-4 max-h-60 overflow-y-auto pr-2">
                                    {/* التقييم */}
                                    <div>
                                        <h5 className="text-2xl font-medium text-gray-700 mb-2">التقييم</h5>
                                        <div className="space-y-2">
                                            {filterOptions.ratingOptions.map((rating) => (
                                                <label key={rating.id} className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-1 rounded">
                                                    <div className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={filters.ratings.includes(rating.id)}
                                                            onChange={() => handleFilterChange('ratings', rating.id)}
                                                            className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                                            style={{ width: "20px" }}
                                                        />
                                                        <span className="mr-3 text-2xl font-bold text-gray-900 ">{rating.label}</span>
                                                    </div>
                                                    {/* <span className="bg-gray-100 text-gray-600 text-2xl px-2 py-1 rounded-full">
                                                        {rating.count}
                                                    </span> */}
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    {/* الميزات الإضافية */}
                                    <div className="pt-2 border-t border-gray-100">
                                        <h5 className="text-2xl font-medium text-gray-700 mb-2">ميزات إضافية</h5>
                                        <div className="space-y-2">
                                            <label className="flex items-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.warranty}
                                                    onChange={() => handleFilterChange('warranty', !filters.warranty)}
                                                    className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                                    style={{ width: "20px" }}
                                                />
                                                <span className="mr-3 text-2xl text-gray-700">ضمان مصنع</span>
                                            </label>
                                            <label className="flex items-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.fastDelivery}
                                                    onChange={() => handleFilterChange('fastDelivery', !filters.fastDelivery)}
                                                    className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                                    style={{ width: "20px" }}
                                                />
                                                <span className="mr-3 text-2xl text-gray-700">توصيل سريع (24 ساعة)</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* أزرار التصفية */}
                        <div className="mt-6 pt-6 border-t border-gray-200 flex justify-end space-x-4 space-x-reverse h-60">
                            <button
                                className="px-6 py-2 bg-white border-2 border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-300"
                                onClick={resetFilters}
                            >
                                إعادة التعيين
                            </button>
                            <button
                                className="px-6 py-2 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-indigo-800 transition-all duration-300 shadow-lg"
                                onClick={() => {
                                    applyFilters();
                                    setShowFilters(false);
                                }}
                            >
                                تطبيق الفلاتر
                            </button>
                        </div>
                    </div>
                )}

            </div>

            {
                (viewMode === 'grid') ?
                    <>
                        {/* شبكة الكاردات */}
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
                            {results.map((part) => (
                                <div className="group bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 lg:hover:-translate-y-2 border border-gray-100 flex flex-col h-full">

                                    {/* شريط الترويج */}
                                    {part.isPromo && (
                                        <div className="absolute top-3 right-3 md:top-4 md:right-4 z-20">
                                            <div className="bg-gradient-to-r from-red-500 to-pink-600 text-white text-2xl md:text-xl lg:text-2xl font-bold py-1 px-2 md:py-1 md:px-3 rounded-lg shadow-lg animate-pulse">
                                                خصم 20%
                                            </div>
                                        </div>
                                    )}

                                    {/* صورة القطعة - ارتفاع متجاوب */}
                                    <div className="relative overflow-hidden h-64 sm:h-56 md:h-60 lg:h-64 xl:h-72">
                                        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-gray-100">
                                            {part.imageUrl ? (
                                                <img
                                                    src={part.imageUrl}
                                                    alt={part.name}
                                                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                                                    loading="lazy"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.style.display = 'none';
                                                    }}
                                                />
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center">
                                                    <div className="text-center px-2">
                                                        <div className="w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-2 md:mb-3 lg:mb-4">
                                                            <svg className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 text-blue-400"
                                                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                                                                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                                                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            </svg>
                                                        </div>
                                                        <p className="text-gray-500 text-2xl md:text-2xl lg:text-xl">صورة القطعة</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* طبقة تدرج */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                                        {/* شعار البراند */}
                                        <div className="absolute top-2 left-2 md:top-3 md:left-3 lg:top-4 lg:left-4 z-10">
                                            <div className="bg-white/90 backdrop-blur-sm rounded-lg md:rounded-xl px-2 py-1.5 md:px-3 md:py-2 shadow-lg flex items-center">
                                                {part.brandLogo ? (
                                                    <img
                                                        src={part.brandLogo}
                                                        alt={part.brand}
                                                        className="h-4 md:h-5 lg:h-6 w-auto max-w-[60px] md:max-w-[80px] lg:max-w-[100px]"
                                                    />
                                                ) : (
                                                    <span className="font-bold text-gray-800 text-2xl md:text-2xl lg:text-xl truncate max-w-[60px] md:max-w-[80px] lg:max-w-[100px]">
                                                        {part.brand}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* حالة التوفر */}
                                        <div className="absolute bottom-2 right-2 md:bottom-3 md:right-3 lg:bottom-4 lg:right-4 z-10">
                                            <div className={`px-2 py-1 md:px-3 md:py-1.5 rounded-full text-2xl md:text-2xl lg:text-xl font-semibold shadow-lg flex items-center ${part.availability === 'متوفر'
                                                ? 'bg-gradient-to-r from-green-500 to-green-900 text-white'
                                                : part.availability === 'طلب مسبق'
                                                    ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white'
                                                    : 'bg-gradient-to-r from-red-400 to-pink-500 text-white'
                                                }`}>
                                                {part.availability === 'متوفر' && (
                                                    <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                    </svg>
                                                )}
                                                {part.availability}
                                            </div>
                                        </div>

                                        {/* رمز القطعة */}
                                        <div className="absolute bottom-2 left-2 md:bottom-3 md:left-3 lg:bottom-4 lg:left-4 z-10">
                                            <div className="bg-black/60 backdrop-blur-sm rounded px-2 py-1 md:rounded-lg md:px-3 md:py-1.5">
                                                <span className="font-mono text-white text-2xl md:text-2xl lg:text-xl font-bold tracking-wide truncate max-w-[80px] md:max-w-[100px] lg:max-w-[120px]">
                                                    {part.partNumber}
                                                </span>
                                            </div>
                                        </div>

                                        {/* زر المفضلة */}
                                        <button className="absolute top-2 right-2 md:top-3 md:right-3 lg:top-4 lg:right-4 z-10 w-8 h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-all duration-300 shadow-lg group/favorite">
                                            <svg className="w-4 h-4 md:w-4.5 md:h-4.5 lg:w-5 lg:h-5 text-gray-600 group-hover/favorite:text-red-500"
                                                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                            </svg>
                                        </button>

                                        {/* زر العرض السريع */}
                                        <button className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 opacity-0 group-hover:opacity-100 transition-all duration-500">
                                            <div className="bg-white/90 backdrop-blur-sm rounded-full p-2 md:p-3 shadow-xl hover:bg-white transition-all duration-300">
                                                <svg className="w-5 h-5 md:w-6 md:h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                </svg>
                                            </div>
                                        </button>
                                    </div>

                                    {/* محتوى الكارد */}
                                    <div className="p-4 md:p-5 lg:p-6 flex-grow flex flex-col">

                                        {/* الفئة */}
                                        <div className="flex items-center mb-2 md:mb-3">
                                            <span className="px-2 py-1 md:px-2.5 md:py-1 bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-600 text-2xl md:text-2xl lg:text-xl font-semibold rounded-full">
                                                {part.category}
                                            </span>
                                            {part.subCategory && (
                                                <span className="mr-2 text-2xl md:text-2xl lg:text-xl text-gray-500 truncate">
                                                    • {part.subCategory}
                                                </span>
                                            )}
                                        </div>

                                        {/* اسم القطعة - مع تقليل الأسطر */}
                                        <h3 className="text-2xl md:text-xl lg:text-2xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors duration-300 overflow-hidden"
                                            style={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                minHeight: '2.5rem',
                                            }}>
                                            {part.name}
                                        </h3>

                                        {/* الوصف - مع تقليل الأسطر */}
                                        <p className="text-2xl md:text-2xl lg:text-xl text-gray-600 mb-3 md:mb-4 overflow-hidden flex-grow"
                                            style={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                minHeight: '2rem',
                                            }}>
                                            {part.description || 'قطعة غيار أصلية عالية الجودة تناسب معظم موديلات السيارات'}
                                        </p>

                                        {/* السعر والإجراءات */}
                                        <div className="mt-auto pt-3 md:pt-4 border-t border-gray-100">
                                            <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-0">
                                                <div>
                                                    <div className="flex items-center flex-wrap gap-1 md:gap-2">
                                                        <span className="text-xl md:text-2xl lg:text-2xl font-bold text-gray-900">
                                                            {part.price}
                                                        </span>
                                                        {part.originalPrice && (
                                                            <span className="text-2xl md:text-2xl lg:text-xl text-gray-400 line-through">
                                                                {part.originalPrice}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="text-2xl md:text-2xl lg:text-xl text-gray-500 mt-1 flex items-center">
                                                        <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                                        </svg>
                                                        {part.stock ? `المخزون: ${part.stock}` : 'آخر قطعة'}
                                                    </div>
                                                </div>

                                                <div className="flex gap-2">
                                                    <button
                                                        className="px-3 py-1.5 md:px-4 md:py-2 bg-gradient-to-r from-blue-900 to-indigo-700 text-white rounded-lg text-2xl md:text-2xl lg:text-xl font-semibold hover:from-blue-700 hover:to-indigo-800 transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center flex-1 min-w-[70px] md:min-w-[80px] lg:min-w-[90px]"
                                                        onClick={() => setSelectedPart(part)}
                                                    >
                                                        <svg className="w-3 h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4 ml-1.5" fill="white" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                        </svg>
                                                        التفاصيل
                                                    </button>

                                                    <button className="px-3 py-1.5 md:px-4 md:py-2 bg-gradient-to-r from-green-500 to-green-900 text-white rounded-lg text-2xl md:text-2xl lg:text-xl font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center flex-1 min-w-[70px] md:min-w-[80px] lg:min-w-[90px]">
                                                        <svg className="w-3 h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4 ml-1.5" fill="white" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                                                        </svg>
                                                        السلة
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* معلومات سريعة */}
                                        <div className="mt-3 md:mt-4 pt-3 md:pt-4 border-t border-gray-100 grid grid-cols-2 gap-2 md:gap-3">
                                            <div className="flex items-center text-2xl md:text-2xl lg:text-xl text-gray-600">
                                                <svg className="w-3 h-3 ml-1.5 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                </svg>
                                                <span className="truncate text-2xl">{part.warranty || 'ضمان 12 شهر'}</span>
                                            </div>
                                            <div className="flex items-center text-2xl md:text-2xl lg:text-xl text-gray-600">
                                                <svg className="w-3 h-3 ml-1.5 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                                </svg>
                                                <span className="truncate text-2xl">{part.delivery || 'توصيل سريع'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                    :
                    <>
                        {/* قائمة الكاردات */}
                        <div className="space-y-4">
                            {results.map((part) => (
                                <div
                                    key={part.id}
                                    className="group bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
                                >
                                    <div className="flex flex-col md:flex-row">
                                        {/* صورة القطعة */}
                                        <div className="md:w-72 h-56 md:h-auto relative overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
                                            {/* صورة الخلفية */}
                                            <div className="absolute inset-0">
                                                {part.imageUrl ? (
                                                    <img
                                                        src={part.imageUrl}
                                                        alt={part.name}
                                                        className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.style.display = 'none';
                                                        }}
                                                    />
                                                ) : (
                                                    // صورة افتراضية
                                                    <div className="w-full h-full flex items-center justify-center">
                                                        <div className="text-center">
                                                            <div className="w-20 h-20 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                                                <svg className="w-10 h-10 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                </svg>
                                                            </div>
                                                            <p className="text-gray-500 text-2xl">صورة القطعة</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* طبقة تدرج فوق الصورة */}
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                                            {/* شعار البراند */}
                                            <div className="absolute top-4 left-4 z-10">
                                                <div className="bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2 shadow-lg flex items-center">
                                                    {part.brandLogo ? (
                                                        <img
                                                            src={part.brandLogo}
                                                            alt={part.brand}
                                                            className="h-5 w-auto"
                                                        />
                                                    ) : (
                                                        <span className="font-bold text-gray-800 text-2xl">{part.brand}</span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* حالة التوفر */}
                                            <div className="absolute top-4 right-4 z-10">
                                                <div className={`px-3 py-1.5 rounded-full text-2xl font-semibold shadow-lg flex items-center ${part.availability === 'متوفر'
                                                    ? 'bg-gradient-to-r from-green-400 to-emerald-500 text-white'
                                                    : part.availability === 'طلب مسبق'
                                                        ? 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white'
                                                        : 'bg-gradient-to-r from-red-400 to-pink-500 text-white'
                                                    }`}>
                                                    {part.availability === 'متوفر' && (
                                                        <svg className="w-3 h-3 ml-1" fill="currentColor" viewBox="0 0 20 20">
                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                        </svg>
                                                    )}
                                                    {part.availability}
                                                </div>
                                            </div>

                                            {/* رمز القطعة */}
                                            <div className="absolute bottom-4 left-4 z-10">
                                                <div className="bg-black/60 backdrop-blur-sm rounded-lg px-3 py-1.5">
                                                    <span className="font-mono text-white text-2xl font-bold tracking-wide">{part.partNumber}</span>
                                                </div>
                                            </div>

                                            {/* عرض الخصم */}
                                            {part.isPromo && (
                                                <div className="absolute bottom-4 right-4 z-10">
                                                    <div className="bg-gradient-to-r from-red-500 to-pink-600 text-white text-2xl font-bold py-1 px-2 rounded-lg shadow-lg">
                                                        خصم {part.discount || '20%'}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* محتوى القطعة */}
                                        <div className="flex-1 p-6">
                                            <div className="flex flex-col lg:flex-row lg:items-start justify-between">
                                                <div className="lg:flex-1">
                                                    {/* الفئة */}
                                                    <div className="flex items-center mb-3">
                                                        <span className="px-2.5 py-1 bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-600 text-2xl font-semibold rounded-full">
                                                            {part.category}
                                                        </span>
                                                        {part.subCategory && (
                                                            <span className="mr-2 text-2xl text-gray-500">• {part.subCategory}</span>
                                                        )}
                                                    </div>

                                                    {/* اسم القطعة ورقمها */}
                                                    <div className="mb-4">
                                                        <h3 className="text-2xl font-bold text-gray-900 mb-1 group-hover:text-blue-600 transition-colors duration-300">
                                                            {part.name}
                                                        </h3>
                                                        <div className="flex items-center text-gray-600 text-2xl">
                                                            <span className="font-mono bg-gray-100 px-2 py-1 rounded text-2xl">رقم القطعة: {part.partNumber}</span>
                                                        </div>
                                                    </div>

                                                    {/* الوصف */}
                                                    <p className="text-gray-600 text-2xl mb-4 line-clamp-2">
                                                        {part.description || 'قطعة غيار أصلية عالية الجودة تناسب معظم موديلات السيارات'}
                                                    </p>


                                                </div>

                                                {/* السعر والإجراءات */}
                                                <div className="lg:w-64 mt-4 lg:mt-0 lg:border-l lg:border-gray-200 lg:pl-6">
                                                    <div className="mb-6">
                                                        <div className="flex items-center mb-2">
                                                            <span className="text-2xl font-bold text-gray-900">{part.price}</span>
                                                            {part.originalPrice && (
                                                                <span className="mr-2 text-2xl text-gray-400 line-through">{part.originalPrice}</span>
                                                            )}
                                                        </div>
                                                        {part.isPromo && (
                                                            <div className="text-2xl text-red-600 font-semibold mb-2">
                                                                وفر {(parseInt(part.originalPrice?.replace(/[^0-9]/g, '') || 0) - parseInt(part.price?.replace(/[^0-9]/g, '') || 0))} ريال
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="space-y-3">
                                                        <button className="w-full px-4 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center group/cart">
                                                            <svg className="w-4 h-4 ml-2 group-hover/cart:animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                                                            </svg>
                                                            إضافة للسلة
                                                        </button>

                                                        <div className="flex space-x-3 space-x-reverse">
                                                            <button
                                                                className="flex-1 px-3 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-600 rounded-lg font-medium hover:from-blue-100 hover:to-indigo-100 transition-all duration-300 flex items-center justify-center group/detail"
                                                                onClick={() => setSelectedPart(part)}
                                                            >
                                                                <svg className="w-4 h-4 ml-2 group-hover/detail:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                                </svg>
                                                                التفاصيل
                                                            </button>

                                                            <button className="flex-1 px-3 py-2 bg-gradient-to-r from-gray-50 to-gray-100 text-gray-600 rounded-lg font-medium hover:from-gray-100 hover:to-gray-200 transition-all duration-300 flex items-center justify-center group/favorite">
                                                                <svg className="w-4 h-4 ml-2 group-hover/favorite:text-red-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                                                </svg>
                                                                المفضلة
                                                            </button>
                                                        </div>

                                                        {/* زر سريع للمقارنة */}
                                                        <button className="w-full px-3 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all duration-300 flex items-center justify-center text-2xl group/compare">
                                                            <svg className="w-4 h-4 ml-2 group-hover/compare:text-blue-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                                            </svg>
                                                            مقارنة
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>

            }
            {/* ترقيم الصفحات */}
            <div className="mt-8 flex flex-col sm:flex-row justify-between items-center">
                <div className="text-gray-600 mb-4 sm:mb-0 text-3xl lg:text-2xl">
                    عرض <span className="font-bold text-2xl">{Math.min(results.length, 10)}</span> من <span className="font-bold text-2xl">{results.length}</span> نتيجة
                </div>

                <div className="flex items-center space-x-5 space-x-reverse">
                    <button className="px-4 py-2 text-2xl bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700 rounded-lg font-medium hover:from-gray-200 hover:to-gray-300 transition-all duration-300 flex items-center">
                        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                        السابق
                    </button>

                    <div className="flex items-center space-x-5 space-x-reverse">
                        {[1, 2, 3, '...', 8].map((page, index) => (
                            <button
                                key={index}
                                className={` text-2xl rounded-lg p-4 font-semibold ${page === 1
                                    ? 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg'
                                    : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                                    }`}
                            >
                                {page}
                            </button>
                        ))}
                    </div>

                    <button className="px-4 py-2 text-2xl bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700 rounded-lg font-medium hover:from-gray-200 hover:to-gray-300 transition-all duration-300 flex items-center">
                        التالي
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>


        </div>
    );


};

export default SearchResults;